import { useCallback } from "react";

import { useAuth } from "../../../context/AuthProvider";
import { useRequest } from "../../../shared/hooks/useRequest";
import { getCheatsheets } from "../api/cheatsheetApi";

export const useCheatsheets = (courseId?: string) => {
    const { user } = useAuth();
    const userId = user?.id;

    // New function only when an id changes, which re-runs the request
    const fetcher = useCallback(
        (signal: AbortSignal) => getCheatsheets(userId as number | string, courseId as string, signal),
        [userId, courseId]
    );

    // Waits until both the user and the course id are known
    return useRequest(userId !== undefined && courseId ? fetcher : null);
};